export const sortCategories = {
    NONE: -1,
    NAME: 0,
    ID: 1,
    DATE: 2,
    SEARCH_SCORE: 3,
    PLAN_STATUS: 4,
    FLAG: 5,
};

export const patientListPlanStageTooltip = {
    MISSING_ALL: "Missing PSA and Pathology Report",
    MISSING_PSA: "Missing PSA",
    MISSING_PATH: "Missing Pathology Report",
};

export const EMPTY_STRING = "";
export const N_A = "N.A.";

export const LIST_ITEM_HEIGHT = 74;
export const CONTAINER_HEIGHT = 435;

export const buttonNames = {
    RESUME: "Resume Case",
    REVIEW: "Review Case",
};

export const SEARCH_BAR_PLACEHOLDER = "Search by name, MRN, or plan ID";
export const MAX_SEARCH_RESULTS = 50;

export const lockedErrorMessage =
    "The case is currently being worked on by another user. Please try again later.";

export const lockedPlanTooltipMsg = (firstName, lastName, email) =>
    `Case is currently being worked on by ${firstName} ${lastName} (${email}). Please check back later.`;

export const DOWNLOAD_PLAN_TOOLTIPS = {
    CEM_GENERATED: "Download case",
    NO_CEM_GENERATED: "CEM not generated",
};
